import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[fuseWidgetToggle]'
})
export class FuseWidgetToggleDirective
{
    constructor(public el: ElementRef)
    {
    }
}



// WEBPACK FOOTER //
// ./src/@fuse/components/widget/widget-toggle.directive.ts